// frontend/src/pages/PayrollDone/usePayRunDoneView.ts
// React Query hook for the pay run's /done-view payload (run + employees + totals in one call).

import { useQuery } from "@tanstack/react-query";
import { API_URL, authHeaders } from "./helpers";
import type { DoneView } from "./types";

/**
 * Fetches the full "done view" payload for a pay run.
 * Hook is disabled until `payRunId` is provided (URL param may be undefined on first render).
 *
 * NOTE: Uses raw `fetch` to preserve original behavior (no silent token refresh).
 * Migration to `apiFetch` can happen in a later cleanup PR.
 */
export function usePayRunDoneView(payRunId: string | undefined) {
  return useQuery<DoneView>({
    queryKey: ["payroll-run-done-view", payRunId],
    queryFn: async function () {
      const res = await fetch(
        API_URL + "/api/v1/payroll/runs/" + payRunId + "/done-view",
        { headers: authHeaders() }
      );
      if (!res.ok) throw new Error("Could not load payroll run.");
      return await res.json();
    },
    enabled: !!payRunId,
    refetchOnWindowFocus: false,
  });
}